import autohotkey from "refractor/autohotkey";
export default autohotkey;